import { render, staticRenderFns } from "./PanelAudio.vue?vue&type=template&id=ff6c887c&"
import script from "./PanelAudio.vue?vue&type=script&lang=js&"
export * from "./PanelAudio.vue?vue&type=script&lang=js&"
import style0 from "./PanelAudio.vue?vue&type=style&index=0&id=ff6c887c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports